window.addEventListener("load", function(){
        if (window.innerWidth < 600 ) {
       var slider = tns({
          container: '.mobile_slider',
          items: 1,
          slideBy: '1',
          nav: true,
          speed: 400,
          mode: 'carousel',
          navPosition: 'bottom',
          autoplayButtonOutput: false,
          autoplay: false,
          controls: false,
          freezable: false,
          touch: true,
          mouseDrag: true,
          preventScrollOnTouch: false,
          rewind: true,
          lazyload: false,
          center: false,
          loop: false,
        responsive: {
          380: {
            items: 1
          },
          640: {
            items: 2
          },
          768: {
            items: 4
          }}
      });
     const el = document.querySelector('.mobile_slider');
     el.classList.remove("grid-wrapper");
      el.classList.remove("row-of-3");
        }
      });